export default __webpack_public_path__ + "static/landing-video-2b788ce542e5f03338ab6a455cfe3793.mp4";